/**
 * In-memory identity for asynchronous UI intent. Access-token renewal retains
 * the user/session/type; a new sign-in does not. This is not authorization:
 * every request still sends its access token for server-side verification.
 */
export function accessSessionIdentity(token: string | null | undefined): string | null {
  if (!token) return null
  try {
    const parts = token.split('.')
    if (parts.length !== 3) return `opaque:${token}`
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const claims = JSON.parse(atob(payload.padEnd(Math.ceil(payload.length / 4) * 4, '=')))
    if ([claims?.sub, claims?.sid, claims?.typ].every(value => typeof value === 'string' && value.length > 0)) {
      return JSON.stringify([claims.sub, claims.sid, claims.typ])
    }
  } catch { /* Opaque or malformed tokens remain isolated by exact token. */ }
  return `opaque:${token}`
}
